"use client"

import React, {useState} from "react";
import {useCompanyInfo} from "@/hooks/useCompanyInfo";
import {ChevronLeftIcon} from "@heroicons/react/24/solid";
import Link from "next/link";
import Spinner from "@/components/tailwindComponents/Spinner";

interface BreadcrumbProps {
    firstRouteName: string,
    firstRoute: string,
    secondRouteName: string | undefined,
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({firstRouteName, firstRoute, secondRouteName}) => {
    const {name} = useCompanyInfo();
    const [expanded, setExpanded] = useState(false);
    return (
        <nav
            className="flex my-1 text-xs md:text-sm whitespace-nowrap overflow-hidden"
            aria-label="Breadcrumb"
        >
            <ol className="inline-flex items-center">
                <li className="inline-flex items-center">
                    <Link href="/" className="ms-1 text-gray-500 md:ms-2">
                        {name}
                    </Link>
                </li>
                <li>
                    <div className="flex items-center">
                        <ChevronLeftIcon className="size-3 mr-2 text-gray-400"/>
                        <Link href={firstRoute}
                              className="ms-1 text-gray-500 md:ms-2">
                            {firstRouteName}
                        </Link>
                    </div>
                </li>
                {secondRouteName && (
                    <li aria-current="page" className="flex items-center max-w-[200px]">
                        <ChevronLeftIcon className="size-3 mr-2 text-gray-400 flex-shrink-0"/>
                        <span
                            className={`ms-1 md:ms-2 text-gray-500 block ${
                                expanded ? "whitespace-normal overflow-visible" : "truncate"
                            }`}
                            onClick={() => setExpanded(!expanded)}
                            style={{cursor: "pointer"}}
                        >
                        {secondRouteName || <Spinner className="size-4"/>}
                    </span>
                    </li>
                )}
            </ol>
        </nav>
    );
}

export default Breadcrumb;